<template>
  <!-- template for the modal component -->
  <!-- <script type="text/x-template" id="modal-template"> -->
  <transition name="modal">
    <div class="car-modal-mask">
      <div class="car-modal-wrapper">
        <div class="car-modal-container">
          <!-- <div class="car-modal-header"> -->
          <!-- <slot name="header"> -->
          <!-- default header -->
          <!-- </slot> -->
          <!-- </div> -->
          <div class="car-modal-body">
            <slot name="body"> default body </slot>

            <div class="car-modal-footer">
              <slot name="footer">
                <primary-btn @click="$emit('close')">
                  {{ $t('modal.closeButton') }}
                </primary-btn>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <!-- </script> -->
</template>

<script>
import PrimaryBtn from '@/components/PrimaryBtn';
export default {
  name: 'Modal',
  components: { PrimaryBtn },
  template: '#modal-template'
};
</script>
